<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Delivery Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="2"
            disabled
            v-decorator="['surat_jalan', { rules: [{ required: false }],
            initialValue: initialData.surat_jalan, }]"
          />
        </a-form-item>
        <a-form-item label="Receiving Date">
          <a-date-picker
            placeholder="Select Date"
            :format="getDefaultDateFormat"
            v-decorator="['tgl_terima', { rules: [{ required: true }],
            initialValue: initialData.tgl_terima, }]"
          />
        </a-form-item>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="6"
            v-decorator="['note', { rules: [{ required: false }],
            initialValue: initialData.note, }]"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "InformasiReceive",
  props: {
    data: {},
    dataShipmentDeliver: {}
  },
  data() {
    return {
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getSites", "getDefaultDateFormat", "getAuth", "getAllBOD"]),
    initialData() {
      return {
        note: this.data.note ? this.data.note : '',
        surat_jalan: this.data.surat_jalan,
        tgl_terima: this.data.tgl_terima ? moment(this.data.tgl_terima) : null,
      };
    },
  },

  async created() {
  },

  methods: {
    moment,
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        Event.$emit("poReceiveItemAset", {
            values
        });
      });
    },
  },

};
</script>